<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table ref="table" pagination :max-items="itemsPerPage" search :data="listCompanies">
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<vs-button
					type="filled"
					class="g-btn-cutomize p-2 font-bold btnCustom"
					icon-pack="feather"
					icon="icon-plus"
					@click.prevent="$emit('valueCreateTypeConfig', 1)"
				>
					<span class="btnTextCustom" v-text="$t('Crud.Create') + ' ' + $t('TypeConfig')"></span>
				</vs-button>
			</div>
			<template slot="thead">
				<vs-th class="g-table--title" sort-key="category" :v-text="$t('Name')"></vs-th>
				<vs-th class="g-table--title" sort-key="name" :v-text="$t('TypeConfigStatus')"></vs-th>
				<vs-th class="g-table--title" sort-key="name" :v-text="$t('TypeConfigAddDateOn')"></vs-th>

				<vs-th
					v-if="typeConfigUpdatePermission || typeConfigDeletePermission"
					class="g-table--title"
					:v-text="$t('Action')"
				></vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<p class="g-table--description truncate">{{ tr.name }}</p>
						</vs-td>
						<vs-td>
							<p class="g-table--description">{{ tr.status_id }}</p>
						</vs-td>
						<vs-td>
							<p class="g-table--description">{{ tr.added_on }}</p>
						</vs-td>

						<vs-td
							v-if="typeConfigUpdatePermission || typeConfigDeletePermission"
							class="g-table--description whitespace-no-wrap"
						>
							<feather-icon
								v-if="typeConfigUpdatePermission"
								icon="Edit2Icon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								class="g-label--normal"
								@click.stop="editData(tr)"
							/>
							<feather-icon
								v-if="typeConfigDeletePermission"
								icon="Trash2Icon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2 g-label--normal"
								@click.stop="openConfirm(tr.id)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import moduleTypeConfigCrud from "@/store/type-config-crud/moduleTypeConfigCrud.js";
import moduleCommon from "@/store/common/moduleCommon.js";

export default {
	name: "TypeConfigCrudListView",
	data() {
		return {
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: null,
		};
	},
	created() {
		// Registra modulo
		if (!moduleTypeConfigCrud.isRegistered) {
			this.$store.registerModule("moduleTypeConfigCrud", moduleTypeConfigCrud);
			moduleTypeConfigCrud.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		this.getActiveStatusCode();
	},
	mounted() {
		this.isMounted = true;
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		// Consulta los tipos de configuraciones encontrados en el estate
		listCompanies() {
			return this.$store.state.moduleTypeConfigCrud.config_list;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listCompanies.length;
		},
		typeConfigUpdatePermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_U");
		},
		typeConfigDeletePermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_D");
		},
	},
	methods: {
		// Pregunta si desea eliminar el tipo seleccionado
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("DeleteTypeConf"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		// Confirma la eliminación del tipo
		acceptAlert() {
			//alert(this.itemSelected)
			this.deleteData(this.itemSelected);
		},
		// Elimina el tipo
		deleteData(id) {
			this.$vs.loading();
			this.$store
				.dispatch("moduleTypeConfigCrud/removeTypeConfig", id)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyConfigDelete"),
						text: this.$t("TextConfirmCompanyConfigDelete"),
					});
					this.$vs.loading.close();
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		// Click en la edicion
		editData(data) {
			this.$emit("selectedCompanyEmit", data);
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		async getActiveStatusCode() {
			try {
				const response = await this.$store.dispatch("moduleCommon/fetchDataRoleStatusCategoryTypology");
				if (response.status !== 200) {
					throw new Error(response.status);
				}
			} catch (error) {}
		},
	},
};
</script>

<style lang="scss" scoped>
#data-list-list-view {
	.vs-con-table {
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			padding: 0 1rem;

			td {
				font-style: normal;
				font-weight: 300;
				font-size: 12px;
				line-height: 15px;
				color: #666666;
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
